import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClosureDetail } from '../../../models';
import { Observable, of, map } from 'rxjs';
import * as fromStore from '../../../store';
import { Store } from '@ngrx/store';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-closure-specifications-modal',
  templateUrl: './closure-specifications-modal.component.html',
  styleUrls: ['./closure-specifications-modal.component.scss']
})
export class ClosureSpecificationsModalComponent implements OnInit, OnDestroy {

  closureLoader$: Observable<boolean> = of(false);
  activeClosure$?: Observable<ClosureDetail | undefined>;
  closureHasDrawing$: Observable<boolean> = of(false);
  closureFlatterFilesIntegrationIsEnabled$: Observable<boolean> = of();
  // @Input() showLoader = false;
  // @Input() product?: ClosureDetail | null;
  // @Input() hasDrawing = false;
  // @Input() configurationFilter?: FormGroup;
  // @Input() additionalDrawings: string[] = [];

  // @Output() getFittingDrawing = new EventEmitter<string>();
  // @Output() getClosureDrawing = new EventEmitter<ClosureDetail>();
  // @Output() getClosureAssociatedDrawing = new EventEmitter<string>();
  constructor(private store: Store<fromStore.State>, public modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.activeClosure$ = this.store.select(fromStore.selectors.CLOSURES.selectActiveClosureDetail);
    this.closureLoader$ = this.store.select(fromStore.selectors.CLOSURES.selectLoader(fromStore.LOADERS.CLOSURES.loadingDetail));
    this.closureHasDrawing$ = this.store.select(fromStore.selectors.CLOSURES.selectClosureHasDrawing);
    this.closureFlatterFilesIntegrationIsEnabled$ = this.store.select(fromStore.selectors.USERPROFILE.selectAppConfigValue('EnableClosureFlatterFilesIntegration')).pipe(map(v => !!v)); 
  }

  ngOnDestroy(): void {
    this.store.dispatch(fromStore.actions.CLOSURES.clearClosure());
  }

  closeModal(reason: string): void {
    this.modal.close(reason);
  }

  onGetClosureFile(detail: ClosureDetail): void {
    this.store.dispatch(fromStore.actions.CLOSURES.loadClosureDrawing({ detail }));
  }

}
